import React, { useState } from "react";
import "../assets/css/Event.css";
import BredcrumpImage from "../assets/images/skin-breadcrum.jpg";
import BreadcrumbSection from "./BreadcrumbSection";
import { useNavigate } from "react-router-dom";
import eventsData from "../data/eventsData";

/**
 * Example usage:
 * <EventsPage />
 *
 * Replace the `events` array with your API data or image imports.
 */

export default function EventsPage() {

  const events = eventsData;


  // Pagination (simple client-side)
  const perPage = 8;
  const [page, setPage] = useState(1);
  const totalPages = Math.ceil(events.length / perPage);
  const start = (page - 1) * perPage;
  const visible = events.slice(start, start + perPage);
  const navigate = useNavigate();

  return (
    <>
      <BreadcrumbSection
        title="Redefining Healthcare with Precision and Passion."
        breadcrumbItems={[
          { label: "Home", to: "/" },

        ]}
        backgroundImage={BredcrumpImage}
      />
      <div className="events-page">
        <h2 className="events-title">Our Events & Milestones</h2>

        <div className="events-grid-wrapper">
          <div className="events-grid">
            {visible.map((ev) => (
              <article key={ev.id} className="event-card">
                <div className="event-media">
                  <div className="event-image-wrapper">
                    <img
                      src={ev.image}
                      alt={ev.title}
                      className="event-bg-blur"
                    />
                    <img
                      src={ev.image}
                      alt={ev.title}
                      className="event-image"
                    />
                  </div>


                  <div className="event-overlay">
                    <h4>{ev.title}</h4>
                    <p>{ev.shortDesc}</p>
                    <button
                      className="details-btn"
                      onClick={() => navigate(`/events/${ev.id}`)}
                    >
                      View Details »
                    </button>
                  </div>
                </div>
              </article>
            ))}

          </div>
        </div>

        {/* PAGINATION SAME */}
        <nav className="events-pagination" aria-label="Events pages">
          <button
            className="pg-btn"
            onClick={() => setPage((p) => Math.max(1, p - 1))}
            disabled={page === 1}
          >
            ‹
          </button>

          {Array.from({ length: totalPages }).map((_, i) => {
            const n = i + 1;
            return (
              <button
                key={n}
                className={`pg-number ${page === n ? "active" : ""}`}
                onClick={() => setPage(n)}
              >
                {n}
              </button>
            );
          })}

          <button
            className="pg-btn"
            onClick={() => setPage((p) => Math.min(totalPages, p + 1))}
            disabled={page === totalPages}
          >
            ›
          </button>
        </nav>
      </div>
    </>
  );
}
